module.exports = __webpack_public_path__ + "bbfa5040ac8e91e19f32ff5f28b9f417.fbx";